function getNestedValue(obj, path) {
  return path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), obj);
}
function getNestedValue2(obj, path) {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}

// Main function to filter the array
function filterArrayObObjsByKeys(array, keys) {
  return array?.filter((obj) => {
    // Check if at least one of the keys has a truthy value (not null or undefined)
    return keys?.some((key) => {
      const value = getNestedValue(obj, key);
      return value !== null && value !== undefined;
    });
  });
}
export function filterObjByKeys(obj, keys) {
  if (!obj || typeof obj !== "object") return null;

  const hasValidValue = keys.some((key) => {
    const value = getNestedValue2(obj, key);
    if (typeof value === "string") {
      return value.trim() !== "";
    }
    return value !== null && value !== undefined;
  });

  if (!hasValidValue) return null;

  const filteredObj = {};
  keys.forEach((key) => {
    const value = getNestedValue2(obj, key);
    if (typeof value === "string") {
      filteredObj[key] = value.trim() !== "" ? value : null;
    } else {
      filteredObj[key] = value !== undefined ? value : null;
    }
  });

  return filteredObj;
}

export default filterArrayObObjsByKeys;
